module.exports = __webpack_public_path__ + "img/media_fed_2.f7774656.png";